import { makeStyles } from '@mui/styles';
import styled from 'styled-components';
import bgLogin from '../../assets/images/homepage/xnuupVan.jpg';
import containerLogin from '../../assets/images/login/xnupp_login_new.png';
import logo from '../../assets/images/login/xnuup_main_logo_black.png';
import border from '../../assets/images/login/border_box_login.png';
import theme from '@/main/style/styleMaterialUIGlobal';
import { Theme } from '@mui/material';

export const useStyles = makeStyles<Theme>(theme => ({
  container: {
    position: 'relative',
    margin: '0',
    padding: '0',
    height: '100%',
    width: '100%',
    display: 'flex !important',
    justifyContent: 'center',
    backgroundImage: `url(${bgLogin})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    flexDirection: 'column',
    overflowX: 'hidden',
    zIndex: 0,

    '@media (max-width: 1025px)': {
      backgroundPosition: 'center'
    }
  },
  appStyle: {
    display: 'initial !important'
  },
  loginScreen: {
    display: 'table-cell',
    margin: '0',
    padding: '0',
    backgroundSize: 'cover'
  },
  formInput: {
    fontFamily: theme.typography.fontFamily,
    outline: '0',
    background: '#f2f2f2',
    width: '100%',
    border: '0',
    margin: '20px 0 15px',
    padding: '15px 15px 15px 45px',
    boxSizing: 'border-box',
    borderRadius: '5px'
  },
  icon: {
    margin: '0 0 0 5px',
    marginTop: '30px',
    position: 'absolute'
  },
  iconImg: {
    width: '25px',
    height: '25px'
  },
  errorMessage: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 13,
    fontWeight: 'bold',
    color: '#FF0000'
  },
  errorIcon: {
    color: '#FF0000',
    verticalAlign: '-6px',
    marginRight: '6px'
  },
  // Change pwd
  title: {
    color: '#ffffff',
    fontFamily: theme.typography.fontFamily,
    fontSize: '13px'
  },
  inputTextCustomQualitas: {
    width: '100%',
    marginBottom: 10,

    '& .MuiInputBase-input': {
      height: 27,
      color: theme.palette.common.black
    },
    '& .MuiInputBase-input:-webkit-autofill, .MuiInputBase-input:-webkit-autofill:focus': {
      transition: 'background-color 600000s 0s, color 600000s 0s'
    },
    '& .MuiInputBase-root': {
      borderRadius: 9,
      backgroundColor: '#FFFFFF'
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-marginDense[data-shrink="false"]': {
      transform: 'translate(14px, 17px) scale(1)'
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(11px, -6px) scale(0.72)',
      paddingLeft: 2
    },
    '& label.Mui-focused': {
      color: '#000'
    },
    '& label.MuiFormLabel-root': {
      fontSize: 16,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      width: 180,
      whiteSpace: 'nowrap'
    },
    '& .MuiFormLabel-root.Mui-error': {
      color: '#f44336'
    },
    '& .MuiFormHelperText-root.Mui-error': {
      wordBreak: 'break-word'
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: 28
    },
    '& .MuiOutlinedInput-root:hover': {
      '& fieldset': {
        borderColor: '#a31e8d'
      }
    },
    '& .MuiOutlinedInput-root.Mui-focused': {
      '& fieldset': {
        borderColor: '#a31e8d'
      }
    }
  },
  inputTextCustom: {
    width: '100%',
    marginBottom: 10,

    '& .MuiInputBase-input': {
      height: 27,
      color: theme.palette.common.black
    },
    '& .MuiInputBase-input:-webkit-autofill, .MuiInputBase-input:-webkit-autofill:focus': {
      transition: 'background-color 600000s 0s, color 600000s 0s'
    },
    '& .MuiInputBase-root': {
      borderRadius: 9,
      backgroundColor: '#FFFFFF'
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-marginDense[data-shrink="false"]': {
      transform: 'translate(14px, 17px) scale(1)'
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(11px, -6px) scale(0.72)',
      paddingLeft: 2
    },
    '& label.Mui-focused': {
      color: '#000'
    },
    '& label.MuiFormLabel-root': {
      fontSize: 16,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      width: 180,
      whiteSpace: 'nowrap'
    },
    '& .MuiFormLabel-root.Mui-error': {
      color: '#f44336'
    },
    '& .MuiFormHelperText-root.Mui-error': {
      wordBreak: 'break-word'
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: 28
    },
    '& .MuiOutlinedInput-root:hover': {
      '& fieldset': {
        borderColor: theme.palette.primary.main
      }
    },
    '& .MuiOutlinedInput-root.Mui-focused': {
      '& fieldset': {
        borderColor: theme.palette.primary.main
      }
    }
  },
  paddingRightLabel: {
    '& legend > span': {
      paddingRight: 12
    }
  },
  containerFooter: {
    width: '100%',
    height: 90,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F6F6F6',
    '@media (max-height: 570px)': {
      height: 40
    }
  },
  contentLabelInformToken: {
    marginTop: 28,
    marginBottom: 20,
    '@media (max-width: 768px)': {
      marginTop: 15,
      marginBottom: 15
    }
  },
  containerLoginMain: {
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'space-between',
    justifyContent: 'center',
    height: '100%'
  },
  safeEnvironment: {
    position: 'absolute',
    right: 47,
    top: 40,
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 500px)': {
      right: 20
    }
  },
  labelSafeEnvironment: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 15,
    fontWeight: 500,
    color: '#363636',
    marginLeft: 10,
    '@media (max-height: 570px)': {
      marginLeft: 5,
      fontSize: 11
    }
  },
  iconSafeEnvironment: {
    color: '#363636',
    width: 15,
    height: 15,
    '@media (max-height: 570px)': {
      width: 11,
      height: 11
    }
  },
  contentLogoProspoectiva: {
    position: 'absolute',
    left: 47,
    top: 32,
    '@media (max-width: 580px)': {
      display: 'none'
    }
  },
  logoPrysmo: {
    backgroundSize: 'cover',
    width: 152,
    height: 144
  },
  containerInputCustom: {
    marginTop: 24,
    '@media (max-width: 450px)': {
      marginTop: 10
    }
  }
}));

export const InsideBox = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LoginForm = styled.div`
  text-align: center;
  position: relative;
`;

export const InputStyle = {
  inputResponsive: {
    minWidth: '120px',
    width: '90%'
  }
};

export const BoxForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${({ theme }) => theme.pantone656C};
  width: auto;
  max-width: 415px;
  min-height: 50vh;
  margin: 0 0 0 2rem;
  padding-bottom: 5%;
  padding-top: 5%;
  border-radius: 10px;

  @media (max-width: 426px) {
    margin: 0 1rem;
    padding-bottom: 5%;
  }
`;

export const BorderBoxForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-image: url(${border});
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  max-width: 415px;
  height: 50px;
  margin: -17px 0 0 2rem;

  @media (max-width: 426px) {
    margin: -17px 0 0 1rem;
  }
`;

export const Logo = styled.div`
  background-image: url(${logo});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 60px;
  margin-bottom: 20px;
  width: 100%;
`;

export const ContainerToggle = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
`;

interface IButtonLoginProps {
  paddingCustom?: string;
}

export const ButtonLogin = styled.button<IButtonLoginProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${({ theme }) => theme.pantone2726C};
  border: none;
  border-radius: 6px;
  padding: ${({ paddingCustom }) => paddingCustom || '0.4rem 1rem'};
  width: 100%;
  margin-top: 10px;
  font-size: 1rem;
  color: ${({ theme }) => theme.pantone656C};
  font-family: ${theme.typography.fontFamily};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ButtonToggleScreen = styled.button`
  font-size: 1rem;
  font-family: ${theme.typography.fontFamily};
  color: ${({ theme }) => theme.pantone2726C};
  text-decoration: underline;
  background: transparent;
  border: none;
  padding: 0;
`;

export const ImageLine = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  max-width: clamp(300px, 100%, 800px);
  height: 180px;
  object-fit: contain;
  z-index: -1;
`;